import { PeriodTimePicker } from 'components/Widgets/PeriodTimePicker';

const PeriodTypeField = ({ selectItem, setNewSelectItem, needTime, disabled }) => {
  return (
    <PeriodTimePicker
      selected={selectItem}
      onChange={setNewSelectItem}
      isPeriodWithTime={needTime}
      disabled={disabled}
    />
  );
};

export default PeriodTypeField;
